<!-- prettier-ignore -->

<div class="confirm-box-container" [ngClass]="{'expand-confirm-box': itemToAdd()}">
    <span>{{ '¿Quieres añadir' | translate }} {{itemToAdd()?.item?.name?.[translate.currentLang]}} {{'a la ruta?' | translate }}</span>
    <div class="confirm-box-container__button-container">
        <button (click)="cancel()" class="cancel">{{ 'Cancelar' | translate }}</button>
        <button (click)="confirm()" class="confirm">{{ 'Aceptar' | translate }}</button>
    </div>
</div>